
import { FaPause, FaPlay } from "react-icons/fa"
import {  useRef, useState } from "react"
import { useInView } from "framer-motion"
import { FaArrowRightLong } from "react-icons/fa6";
import Heading from "../components/heading"
import CampusLifeCard from "../components/campusLifeCard"
import { Link } from "react-router-dom";
import { routes } from "../routes";

import { RowCardWithImageSkelton } from "../components/skeltons";
import { useSelector } from "react-redux";
import { retrunAssets } from "../utils/getAssets";

const CampusLife = () => {
    const poster = "/assets/poster2.svg"
    const vid = "/assets/hero.mp4"

    const camp1 = useRef(null)
    const camp2 = useRef(null)
    const ref = useRef(null)
    // const isInViewRef = useInView(ref, { once: true });
    const isInViewC1 = useInView(camp1, { once: true });
    const isInViewC2 = useInView(camp2, { once: true });
    const [title, ] = useState("Exploring Campus Culture: Your Guide to Vibrant University Life")
    const videoRef = useRef(null)
    const [play, setPlay] = useState(false)

    const onPlay = () => {
        videoRef.current.play()
        setPlay(true)
    }
    const onPause = () => {
        videoRef.current.pause()
        setPlay(false)
    }
    const [loading, ] = useState(false)
   
    
    const state = useSelector(state => state.homepage)
    const data = state.data?.properties?.campusLife?.items.map(d => {
        return {
            img: retrunAssets(d?.content?.properties?.image[0].url),
            size: 80,
            title: d?.content?.properties?.title,
            description: d?.content?.properties?.description,
            link: `/${routes.campusLife.main}`
        }
    }
    )



    return (
        <div ref={ref} className="relative bg-[#f3f3f3] md:h-auto text-black w-full p-2 md:p-6 flex items-start justify-center overflow-x-hidden  ">
            <div className="md:max-w-6xl 2xl:max-w-[90rem] w-full h-full p-2 md:p-3  flex flex-col  justify-between lg:flex-row gap-16 ">
                <div
                    ref={camp1}
                    style={{
                        transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
                    }}
                    className={`flex flex-1 flex-col items-start justify-start text-black w-full  self-stretch gap-3 ${isInViewC1 ? "!translate-x-0 !translate-y-0 opacity-100" : "!-translate-x-[100%] !translate-y-0 opacity-0"}`}>
                    <div className="flex items-center justify-center md:justify-start w-full">
                        <Heading name="Campus Life" />
                    </div>
                    {
                        loading ?
                            <h1 className="font-bold text-2xl 2xl:text-4xl h-5 bg-gray-200/30 animate-pulse md:w-[30rem] 2xl:w-[50rem]"></h1>
                            :
                            <h1 className="font-bold text-2xl 2xl:text-4xl md:w-[30rem] 2xl:w-[50rem]">{title}</h1>
                    }
                    <div className="w-full rounded-lg relative overflow-hidden flex   mt-2 group">
                        <video ref={videoRef} poster={poster} muted className="rounded-lg aspect-video object-cover w-full h-auto">
                            <source src={vid} type="video/mp4" />
                            <track kind="captions"></track>
                        </video>
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 transition-all ">
                            {
                                play ?
                                    <button aria-label="pauseBtn" className="text-[#f3f3f3] hidden group-hover:block" onClick={onPause}><FaPause size={40} /></button>
                                    : <button aria-label="playBtn" className="text-[#f3f3f3]" onClick={onPlay}><FaPlay size={40} /></button>
                            }

                        </div>
                    </div>
                </div>
                <div
                    className="flex flex-col   gap-3 flex-1 h-full">
                    <div
                        ref={camp2}
                        className="w-full flex-1  flex flex-col justify-between gap-3 overflow-hidden">
                        {
                            loading ?
                                [0, 1, 2, 3].map(index =>
                                    <div key={index}

                                        style={{
                                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) " + (500 + (index * 100)) + "ms"
                                        }}
                                        className={` ${isInViewC2 ? "!-translate-x-0 !translate-y-0 opacity-100 " : " !translate-x-[100%] !translate-y-0 opacity-0"}`}
                                    >

                                        <RowCardWithImageSkelton bg="bg-gray-300" />

                                    </div>
                                )
                                :

                                data?.slice(0, 4).map((card, index) => (
                                    <div key={index}

                                        style={{
                                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) " + (500 + (index * 100)) + "ms"
                                        }}
                                        className={` ${isInViewC2 ? "!-translate-x-0 !translate-y-0 opacity-100 " : " !translate-x-[100%] !translate-y-0 opacity-0"}`}
                                    >

                                        <CampusLifeCard  {...card} light={true} />

                                    </div>
                                ))
                        }
                    </div>
                    <p className="text-sm 2xl:text-sm whitespace-pre-line max-w-sm break-all text-gray-700">
                        Located in the corridor of Putrajaya and in the breeze of Bandar Muadzam Shah, Pahang, UNITEN campuses are inside some of the best cities in Malaysia for students.
                    </p>
                    <Link to={`${routes.campusLife.main}`} className="flex gap-1 items-center p-2 px-3 rounded-sm bg-[#9c0000] text-white w-fit text-xs 2xl:text-sm">
                        Explore Campus
                        <FaArrowRightLong />
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default CampusLife